import { render, staticRenderFns } from "./settlementSetting.vue?vue&type=template&id=80cfb9cc&scoped=true"
import script from "./settlementSetting.vue?vue&type=script&lang=js"
export * from "./settlementSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cfb9cc",
  null
  
)

export default component.exports